export default {
  client: {
    shops: {
      data: []
    },
    banks: {
      data: []
    }
  },
  clientsLoaded: {},
  totalMoney: 0
}



// WEBPACK FOOTER //
// ./src/components/client/store/state.js